<div class="lg-container">
  <cc-lg-color-bubble [control]="control" color="light-grey"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="light-blue"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="turquoise"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="light-green"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="green"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="violet"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="plumb"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="light-pink"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="red"></cc-lg-color-bubble>
  <cc-lg-color-bubble [control]="control" color="orange"></cc-lg-color-bubble>
</div>
